<template>
  <div class="flex-container">
    <label :for="`FileInput_${id}`" class="hitbox">
      <span
        class="input"
        :class="{
          'input--disabled': disabled,
          'input--error': validationError,
          'input--placeholder': !filename,
          'input--disabled': disabled,
        }"
      >
        {{ inputText }}
      </span>
      <Button
        @click.native="pickFile"
        buttonStyle="secondary"
        :buttonHeight="56"
        :disabled="disabled"
        >{{ buttonLabel }}</Button
      >
      <input
        :id="`FileInput_${id}`"
        type="file"
        :accept="accept"
        :multiple="false"
        ref="file"
        v-show="false"
        @change="onChange"
        :disabled="disabled"
      />
    </label>
    <ValidationMessage
      :displayInvalid="validationError"
      :validation-message="validationErrorMessage"
    />
  </div>
</template>

<script>
import Button from "../Button.vue";
import InputBase from "./mixins/InputBase";

let id = 0;

export default {
  name: "FileInput",
  mixins: [InputBase],
  components: {
    Button,
  },
  props: {
    /**
     * @vuese
     * Shorthand for accept attribute. When shorthand is not supported it will fallback to whatever is passed as prop.
     */
    type: {
      type: String,
      required: true,
    },
    // The label for the button.
    buttonLabel: {
      type: String,
      default: "Select",
    },
    // Placeholder text when no selection has been made yet.
    placeholderText: {
      type: String,
      required: true,
    },
    // Disabling the input.
    disabled: {
      type: Boolean,
      default: false,
    },
    // Toggle the validation state styling.
    validationError: {
      type: Boolean,
      default: false,
    },
    // Error message that gets shown when validationError is true.
    validationErrorMessage: {
      type: String,
    },
  },
  computed: {
    accept() {
      switch (this.type) {
        case "image":
          return "image/*";
        default:
          return this.type;
      }
    },
    inputText() {
      if (!this.filename) return this.placeholderText;
      return this.filename;
    },
    filename() {
      try {
        const { name } = this.inputValue;
        return this.abbreviateString(name);
      } catch (e) {
        return null;
      }
    },
    isFile() {
      if (!this.inputValue) return false;
      return this.inputValue.toString() === "[object File]";
    },
  },
  methods: {
    abbreviateString(string) {
      if (string.length < 36) return string;
      let abbreviatedString = "";
      abbreviatedString += string.substring(0, 11);
      abbreviatedString += "…";
      abbreviatedString += string.substring(string.length - 12, string.length);
      return abbreviatedString;
    },
    pickFile() {
      this.$refs.file.click();
    },
    onChange(event) {
      if (!event.target.files || !event.target.files.length) return;
      const file = event.target.files[0];
      this.inputValue = file;
    },
  },
  beforeCreate() {
    this.id = id.toString();
    id += 1;
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables";
.flex-container {
  display: flex;
  flex-direction: column;
}

.hitbox {
  display: flex;
  align-items: center;
}

.input {
  @extend %body1_style;
  width: 100%;
  max-width: 400px;
  border: 1px solid $grey_mischka;
  border-radius: 4px;
  height: 56px;
  margin-right: 16px;
  display: flex;
  background-color: $white;
  overflow: hidden;
  white-space: nowrap;
  padding: 14px 16px;

  &.input--disabled {
    background-color: #f9f9f9;
    border: 1px solid $grey_mischka;
  }

  &.input--error {
    border: 1px solid $red;
  }

  &.input--placeholder {
    color: $grey_bombay;
  }

  &.input--disabled {
    color: $grey_mischka;
  }
}
</style>
